import type { ApiKey, CreateApiKeyRequest, CreateApiKeyResponse, UpdateApiKeyRequest } from '@/stores/auth'
import { demoApi } from './db'

export const apiKeysApi = {
	getApiKeys: async (_tenantId?: string, _impersonateAdmin?: boolean): Promise<ApiKey[]> => {
		const res = await demoApi.get<{ keys: ApiKey[] }>('/api-keys')
		return res.keys || []
	},
	createApiKey: async (
		request: CreateApiKeyRequest,
		_tenantId?: string,
		_impersonateAdmin?: boolean,
	): Promise<CreateApiKeyResponse> => {
		//TODO: update apikeys section with expiry_period and rate_limit in demo.
		const insert = await demoApi.post<{ status: string; id: number; key: string }>('/api-keys', {
			name: request.name,
		})
		return {
			status: 'created',
			id: insert.id,
			key: insert.key,
		}
	},
	updateApiKey: async (
		id: number,
		request: UpdateApiKeyRequest,
		_tenantId?: string,
		_impersonateAdmin?: boolean,
	): Promise<{ status: string }> => {
		await demoApi.put(`/api-keys/${id}`, { name: request.name })
		return { status: 'success' }
	},
	deleteApiKey: async (id: number, _tenantId?: string, _impersonateAdmin?: boolean): Promise<{ status: string }> => {
		await demoApi.delete(`/api-keys/${id}`)
		return { status: 'success' }
	},
}
